<style>
  @media only screen and (max-width: 665px) {
    .dropdown.al-user-profile.logout{
      padding-bottom: 200px;
    }
}
 .dropdown.al-user-profile table{
    margin-top: -14px;
    color: white;
    /* background: #1b2b36;
    background-color: #1b2b36 !important; */
    font-size: 12px;
  }
  @media screen and (max-width: 1147px) {
  .dropdown.al-user-profile table {
    margin-top: -34px;
  }
  .al-user-profile-name{
     margin-top: -20px;

  }
}
  @media screen and (max-width: 659px) {
  .dropdown.al-user-profile table {
    margin-top: -12px;
  }
   .al-user-profile-name{
     margin-top: -12px;

  }
}



</style>
<form [formGroup]="form" style="padding-bottom:15px;">
  <div
    class="page-top clearfix"
    baScrollPosition
    maxHeight="50"
    (scrollChange)="scrolledChanged($event)"
    [ngClass]="{scrolled: isScrolled}"
  >
    <a routerLink="/pages/dashboard" class="al-logo clearfix"
      ><span>JOB</span>CARD</a
    >
    <a
      href
      (click)="toggleMenu()"
      class="collapse-menu-link glyphicon glyphicon-menu-hamburger"
    ></a>

    <div class="search" style="width: 50%">
      <!-- <i class="ion-ios-search-strong" ng-click="startSearch()"></i>
    <input id="searchInput" type="text" placeholder="Search for..."> -->
      <b style="font-size: 20px; color: #339d91">{{fname}}</b
      ><b style="font-size: 20px; color: #ffffff">{{sname}}</b>
      <a style="color: a4a9ad">{{tname}}</a>
    </div>

    <div class="user-profile clearfix logout" style="min-width: 0px !important; margin-top: 20px;">
      <!--<div class="btn-group" dropdown>
      <button type="button" class="btn btn-primary" dropdownToggle addToggleClass="true">
        Primary
      </button>
      <ul class="dropdown-menu" dropdownMenu>
        <li class="dropdown-item"><a href="#">Action</a></li>
        <li class="dropdown-item"><a href="#">Another action</a></li>
        <li class="dropdown-item"><a href="#">Something else here</a></li>
        <li class="dropdown-divider"></li>
        <li class="dropdown-item"><a href="#">Separated link</a></li>
      </ul>
    </div>-->

      <div class="dropdown al-user-profile logout">
        <a
          class="profile-toggle-link dropdown-toggle"
          id="user-profile-dd"
          data-toggle="dropdown"
          aria-expanded="false"
          (click)="logout()"
        >
          <!-- <img src="{{ ( 'demo' | baProfilePicture ) }}"/> -->
          <span style="background:#339d91; padding:5px 15px; color:#fff; border-radius:5px;">Logout</span>
          
        </a>
      </div>

      <!-- <ba-msg-center></ba-msg-center> -->
    </div>
    <div class="user-profile clearfix" style="margin-top: 20px">
      <!--<div class="btn-group" dropdown>
      <button type="button" class="btn btn-primary" dropdownToggle addToggleClass="true">
        Primary
      </button>
      <ul class="dropdown-menu" dropdownMenu>
        <li class="dropdown-item"><a href="#">Action</a></li>
        <li class="dropdown-item"><a href="#">Another action</a></li>
        <li class="dropdown-item"><a href="#">Something else here</a></li>
        <li class="dropdown-divider"></li>
        <li class="dropdown-item"><a href="#">Separated link</a></li>
      </ul>
    </div>-->

      <div class="dropdown al-user-profile al-user-profile-name">
        <a
          class="profile-toggle-link dropdown-toggle"
          id="user-profile-dd"
          data-toggle="dropdown"
          aria-expanded="false"
        >
        <b style="font-size: 17px;  font-weight: 500;"> <span class="glyphicon glyphicon-user" style="display:initial; margin-right:7px;"></span>{{login}}</b>
        </a>
      </div>
      <div class="dropdown al-user-profile">
        <a
          class="profile-toggle-link dropdown-toggle"
          id="user-profile-dd"
          data-toggle="dropdown"
          aria-expanded="false"
          style="width: 100px"
        >
          <table
            style="">
            <tr style="border-bottom: 1pt solid #000">
              <input
                type="text"
                formControlName="entrymiti"
                placeholder="yyyy-mm-dd"
                style="
                  margin-right: 5px;
                  width: 90px;
                  background-color: #ffffff ;
                  border:none;
                  
                "
                id="nepaliDate2"
                disabled
              />
            </tr>
            <tr style="color: #000; white-space: pre-wrap;">
              {{now | date:'medium'}}
            </tr>
          </table>
        </a>
      </div>
      <!-- <b style="font-size: 17px;color: #ffffff; ">{{date}}</b><br />
    <b style="font-size: 17px;color: #ffffff; ">{{date}}</b>
    <b style="font-size: 17px;color: #ffffff; ">{{now | date:'medium'}}</b> -->

      <!-- <ba-msg-center></ba-msg-center> -->
    </div>
    <!-- <div class="search" style="width:300px"></div> -->
  </div>
</form>

